import { FC } from 'react';

const Loader: FC = () => (
  <div className="flex justify-center pt-[10%]">
    <div className="self-center h-20 w-20 animate-spin rounded-full border-2 border-cyan-500 border-r-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]" />
  </div>
);

export default Loader;
